export default {
  gameCard: {
    colors: {
      white: '#ffffff',
      black: '#000',
      containerGradient1: 'rgba(199, 199, 199, 0.2)',
      containerGradient2: 'rgba(0, 0, 0, 0.2)',
      containerBorder: '#979797',
      vs: '#000',
      separator: '#000',
      weekdayText: '#5e5e5e',
      monthDayText: '#000',
    },
  },
};
